// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"24479e7e","453":"2ceafeff"}[chunkId] + ".chunk.js";
};